import clsx from "clsx";
import React, { ChangeEvent } from "react";
import { UseFormRegister, FieldValues, Path, RegisterOptions } from "react-hook-form";

export type RadioOption = {
  label: string;
  subLabel?: string;
  value: string | number;
};

export const RadioButton = <T extends FieldValues>({
  name,
  register,
  required = false,
  options,
  direction,
  defaultValue,
  minWidth = "min-w-[90px]",
  onChange,
  className = "",
  isDisabled = false,
}: {
  name: Path<T>;
  register: UseFormRegister<T>;
  options: RadioOption[];
  required?: boolean;
  direction: "vertical" | "horizontal";
  defaultValue?: string | number;
  minWidth?: string;
  onChange?: (value: string) => void;
  className?: string;
  isDisabled?: boolean;
}) => {
  const getRequired: RegisterOptions<T, Path<T>> | undefined = required ? { required: "選択してください" } : {};

  const registerOption = onChange
    ? { ...getRequired, onChange: (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value) }
    : { ...getRequired };

  return (
    <div
      className={clsx(`flex w-fit justify-center gap-6`, direction === "vertical" ? "flex-col" : "flex-row", className)}
    >
      {options.map((option, index) => (
        <label
          key={index}
          className={clsx(`flex cursor-pointer items-center gap-2.5`, minWidth, isDisabled && "!cursor-not-allowed")}
        >
          <input
            type="radio"
            className={clsx("custom-radio", isDisabled && "!cursor-not-allowed")}
            {...register(name, registerOption)}
            value={option.value}
            defaultChecked={option.value === defaultValue}
            disabled={isDisabled}
          />
          <span className="shrink-0 text-s">{option.label}</span>
          {option.subLabel && <span className="text-s text-gray">{option.subLabel}</span>}
        </label>
      ))}
    </div>
  );
};

export default RadioButton;
